export const room1Exports = [
      `Sevasti-Rooms/room2/ITSK6028.jpg`,
      `Sevasti-Rooms/room2/1.jpg`,
      `Sevasti-Rooms/room2/ITSK6078.jpg`,
      `Sevasti-Rooms/room2/ITSK6075.jpg`,
      `Sevasti-Rooms/room2/ITSK6076.jpg`,
      `Sevasti-Rooms/room2/ITSK6065.jpg`,
      `Sevasti-Rooms/room2/ITSK6055.jpg`,
      `Sevasti-Rooms/room2/ITSK6046.jpg`,
      `Sevasti-Rooms/room2/ITSK6052.jpg`,
      `Sevasti-Rooms/room2/ITSK6042.jpg`,
      `Sevasti-Rooms/room2/ITSK6041.jpg`,
      `Sevasti-Rooms/room2/ITSK6037.jpg`,
      `Sevasti-Rooms/room2/ITSK6039.jpg`,
      `Sevasti-Rooms/room2/ITSK6035.jpg`,
      `Sevasti-Rooms/room2/ITSK6030.jpg`,
      `Sevasti-Rooms/room2/ITSK6097.jpg`,
      `Sevasti-Rooms/room2/ITSK6100.jpg`,
      `Sevasti-Rooms/room2/ITSK6022.jpg`,
      `Sevasti-Rooms/room2/ITSK6083.jpg`,
      `Sevasti-Rooms/room2/ITSK6082.jpg`,
      `Sevasti-Rooms/room2/ITSK6087.jpg`,
      `Sevasti-Rooms/room2/ITSK6079.jpg`,

    ]

    export const room2Exports = [
        `Sevasti-Rooms/room1/016.JPG`,
        `Sevasti-Rooms/room1/014.JPG`,
        `Sevasti-Rooms/room1/015.JPG`,
        `Sevasti-Rooms/room1/018.JPG`,
        `Sevasti-Rooms/room1/017.JPG`,
      `Sevasti-Rooms/room1/039.JPG`,
      `Sevasti-Rooms/room1/020.JPG`,
      `Sevasti-Rooms/room1/017.JPG`,
      `Sevasti-Rooms/room1/019.JPG`,
    ]

    export const room3Exports = [
      `Sevasti-Rooms/room3/room3-1.jpg`,
    ]